/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValidateAuthIdResponse } from '../models/ValidateAuthIdResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PendingAuthService {
    /**
     * Load Auth
     * Complete a pending authentication session and return SAML/OIDC response HTML.
     * @param pendingAuthSession
     * @returns string Successful Response
     * @throws ApiError
     */
    public static loadAuth(
        pendingAuthSession?: (string | null),
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/load_auth',
            cookies: {
                'pending_auth_session': pendingAuthSession,
            },
            errors: {
                401: `Pending auth session cookie missing or invalid`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Validate Auth ID
     * Check whether the pending auth session in the cookie is still valid.
     * @param pendingAuthSession
     * @returns ValidateAuthIdResponse Successful Response
     * @throws ApiError
     */
    public static validateAuthId(
        pendingAuthSession?: (string | null),
    ): CancelablePromise<ValidateAuthIdResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validate-auth-id',
            cookies: {
                'pending_auth_session': pendingAuthSession,
            },
            errors: {
                401: `Pending auth session cookie missing or invalid`,
                422: `Validation Error`,
            },
        });
    }
}
